import { render, staticRenderFns } from "./AppStep20.vue?vue&type=template&id=4b0533c6"
import script from "./AppStep20.vue?vue&type=script&lang=js"
export * from "./AppStep20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports